import { render, staticRenderFns } from "./PositionPro.vue?vue&type=template&id=20de022e&scoped=true&"
import script from "./PositionPro.vue?vue&type=script&lang=js&"
export * from "./PositionPro.vue?vue&type=script&lang=js&"
import style0 from "./PositionPro.vue?vue&type=style&index=0&id=20de022e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20de022e",
  null
  
)

export default component.exports